import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, RichText, InspectorControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import MediaHandler from '../components/media-handler';
import { PanelBody, ColorPalette } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

registerBlockType('garden/service-card', {
    apiVersion: 3,
    title: __('Karta usługi', 'garden'),
    icon: 'yes-alt',
    category: 'garden',
    parent: ['garden/services-grid'],
    supports: {
        anchor: true
    },
    attributes: {
        title: {
            type: 'string',
            source: 'html',
            selector: 'h5',
            default: "",
        },
        mediaUrl: {
            type: 'string',
            default: ''
        },
        mediaAlt: {
            type: 'string',
            default: ''
        },
        backgroundColor: {
            type: 'string',
            default: ''
        },
        textColor: {
            type: 'string',
            default: ''
        },
        anchor: {
            type: 'string',
            default: ''
        }
    },
    edit: ({ attributes, setAttributes }) => {
        const { title, mediaUrl, mediaAlt, backgroundColor, textColor } = attributes;
        const blockProps = useBlockProps({
            style: { backgroundColor, color: textColor }
        });

        const themeColors = useSelect((select) => {
            return select('core/block-editor').getSettings().colors;
        }, []);

        return (
            <>
                <InspectorControls>
                    <PanelBody title={__('Ustawienia karty', 'psgarden')}>
                        <div className="components-base-control">
                            <label className="components-base-control__label">
                                {__('Kolor tła', 'psgarden')}
                            </label>
                            <ColorPalette
                                value={backgroundColor}
                                onChange={(color) => setAttributes({ backgroundColor: color })}
                                colors={themeColors}
                            />
                        </div>
                        <div className="components-base-control" style={{ marginTop: '1rem' }}>
                            <label className="components-base-control__label">
                                {__('Kolor tekstu', 'psgarden')}
                            </label>
                            <ColorPalette
                                value={textColor}
                                onChange={(color) => setAttributes({ textColor: color })}
                                colors={themeColors}
                            />
                        </div>
                    </PanelBody>
                </InspectorControls>
                <div {...blockProps}>
                    <MediaHandler
                        attributes={{ mediaUrl, mediaAlt }}
                        setAttributes={setAttributes}
                        imageSize="thumbnail"
                        customButtonLabel={__('Wybierz ikonę', 'garden')}
                        customRemoveLabel={__('Usuń ikonę', 'garden')}
                    >
                        <span className="service-icon">
                            {mediaUrl && <img src={mediaUrl} alt={mediaAlt} />}
                        </span>
                        <RichText
                            tagName="h5"
                            className="service-title"
                            value={title}
                            onChange={(title) => setAttributes({ title })}
                            placeholder={__('Wprowadź nazwę usługi...', 'garden')}
                        />
                    </MediaHandler>
                </div>
            </>
        );
    },
    save: ({ attributes }) => {
        const blockProps = useBlockProps.save({
            className: 'wp-block',
            style: { backgroundColor: attributes.backgroundColor, color: attributes.textColor }
        });

        const { title, mediaUrl, mediaAlt } = attributes;

        return (
            <div {...blockProps}>
                <span className="service-icon">
                    {mediaUrl && <img src={mediaUrl} alt={mediaAlt} />}
                </span>
                <RichText.Content
                    tagName="h5"
                    className="service-title"
                    value={title}
                />
            </div>
        );
    }
}); 
